import { Container, Stack, Typography } from "@mui/material";
import Iconify from "src/components/iconify";

const GoogleAccounts = () => {
    return (
        <Container sx={{ height: "100vh" }}>
            <Stack direction="column" marginTop={5}>
                <Stack direction="column" spacing={2} alignItems="center">
                    <img src={"/assets/logo_crossbrand.png"} alt="Cross Brand" width={100} />
                    <Iconify color="success.main" icon="mdi:check-circle" width={65} height={65} />
                    <Typography fontWeight={600} variant="body1">Thank you for granting your access to Cross Brand.</Typography>
                    <Typography variant="body1">You can now close this page</Typography>
                </Stack>
            </Stack>
        </Container>
    )
};

export default GoogleAccounts;